import React from 'react';
import classNames from 'classnames';

import DemographicChart from 'layouts/salaryJobPage/salaryDemographics/DemographicCart.jsx';
import { formatCurrency, formatEducationLabel } from 'utils';

import { buildCmpSubpagesUrls } from '../../../../utils';
import { CMP_SUBPAGES } from '../../../../utils/constant';
import ChartTable from '../chartTable';
import GenderEthnicLanguageDiversity from '../GenderEthnicLanguageDiversity';

import classes from './index.module.css';

const educationHead = [
  { title: 'Education', value: 'education' },
  { title: 'Salary', value: 'salary' },
];

const DegreeLevelTypes = ({
  jobTitle,
  jobTitlePlural,
  salaryEstimates,
  educationIncomeBlurb,
  degreePieChart,
  mostCommonDegreesContentBlurb,
  filterLogEventCallback,
  filterValueRange,
  educationIndex,
  locations,
}) => {
  const getTableData = (tableRowData = {}, columnName1, columnName2) => {
    return Object.keys(tableRowData).map((key) => ({
      [columnName1]: formatEducationLabel(key),
      [columnName2]: tableRowData[key],
    }));
  };
  const showGapByEduChart = Object.values(salaryEstimates.byDegree)?.length > 1;

  return (
    <section
      id="degree-level-types"
      className={classNames(classes.degreeLevelTypesContainer, 'w-730')}
    >
      <h2 className="brandonH2 w-730 z-mb-48">{`${jobTitle} educational attainment`}</h2>

      {degreePieChart && (
        <>
          <GenderEthnicLanguageDiversity
            jobTitle={jobTitle}
            jobTitlePlural={jobTitlePlural}
            mostCommonDegreesContentBlurb={mostCommonDegreesContentBlurb}
            pieChartData={[degreePieChart]}
            filterLogEventCallback={filterLogEventCallback}
            filterValueRange={filterValueRange}
            noTitle
            locations={locations}
          />
          <div className="section-separator-medium"></div>
        </>
      )}

      {showGapByEduChart && !!salaryEstimates?.byDegree && (
        <div className={classes.salaryDemographicChart}>
          <h3 className="cmpSectionh4 text-capitalize">{`${jobTitle} wage gap by degree level`}</h3>
          {educationIncomeBlurb && (
            <div
              className="z-mt-24"
              dangerouslySetInnerHTML={{ __html: educationIncomeBlurb.content }}
            />
          )}
          <div className="mt-5">
            <div className="d-none d-md-block">
              <DemographicChart
                xLabels={Object.keys(salaryEstimates.byDegree).map((key) =>
                  formatEducationLabel(key)
                )}
                values={Object.values(salaryEstimates.byDegree)}
              />
            </div>
            <div className="d-block d-md-none">
              <ChartTable
                heads={educationHead}
                tableData={getTableData(salaryEstimates.byDegree, 'education', 'salary')}
                defaultSortedColumn="salary"
                formatter={formatCurrency}
              />
            </div>
            {educationIndex && (
              <div className="mt-5">
                <a
                  className="link font-14"
                  href={buildCmpSubpagesUrls(jobTitle, '', CMP_SUBPAGES.EDUCATION)}
                >
                  {`Learn More About ${jobTitle} Required Education`}
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default DegreeLevelTypes;
